var map = {
	"./about.jpeg": "Zhyv",
	"./bg_index_head.png": "jLkX",
	"./bg_login.png": "m30q",
	"./cnBtn.png": "5DwV",
	"./enBtn.png": "ldrp",
	"./icon_add_picture.png": "HDHu",
	"./icon_address.png": "+Pvt",
	"./icon_car.png": "nbeZ",
	"./icon_car_bg.png": "5yF4",
	"./icon_close.png": "ShLw",
	"./icon_close_red.png": "urzT",
	"./icon_fascia.png": "Hbj/",
	"./icon_head1.png": "7I0W",
	"./icon_head2.png": "zSL7",
	"./icon_head3.png": "W2ne",
	"./icon_head4.png": "YhkB",
	"./icon_home.png": "Ye28",
	"./icon_login1.png": "HjIr",
	"./icon_login2.png": "b+CF",
	"./icon_login3.png": "vX0K",
	"./icon_login4.png": "w75E",
	"./icon_logo.png": "YS2w",
	"./icon_open.png": "BR0y",
	"./icon_placeholder_normal.png": "tYAW",
	"./icon_success.png": "JsnA",
	"./icon_time.png": "v35C",
	"./img1.png": "GmyW",
	"./img2.png": "fhjV",
	"./img3.png": "ro8C",
	"./img4.png": "MKzk",
	"./manual.png": "BZ3E",
	"./wx_qcode.png": "t7rx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 23